<template>
  <div class="pagamento">
    <Topo />
    <div class="row">
      <div class="col-md-4 mt-3">
        <Menu />
      </div>
      <!-- Conteudo das views -->
      <div class="col-md-8 mt-3">
        <!-- conteudo views -->
  
        <div class="row">
          <div class="card col-md-12">
            <div class="card-body">
              <h5 class="card-title">Alteração de Senha</h5>
              <h6 class="card-subtitle mb-2 text-muted">Informe uma nova senha</h6>
              <p class="card-text">
                <input type="password" class="form-control" v-model="passwd" maxlength="15" placeholder="Nova senha" />
              </p>
              <button type="button" class="btn btn-primary ml-1" @click="changePasswd">Modificar</button>
            </div>
          </div>
  
          <div class="card col-md-12 mt-4">
            <div class="card-body">
              <h5 class="card-title">Alteração de E-mail</h5>
              <h6 class="card-subtitle mb-2 text-muted">Informe seu novo e-mail</h6>
              <p class="card-text">
                <input type="text" class="form-control" v-model="mail" maxlength="80" placeholder="E-mail" />
              </p>
              <button type="button" class="btn btn-primary ml-1" @click="changeMail">Salvar</button>
            </div>
          </div>
          <div class="card col-md-12 mt-4" v-if="profile === 'HOLDER'">
            <div class="card-body">
              <h5 class="card-title">Cancelar assinatura</h5>
              <button type="button" class="btn btn-primary ml-1" @click="cancel">Cancelar</button>
            </div>
          </div>
        </div>
  
      </div>
    </div>
    <Rodape />
  </div>
</template>

<script>
import Topo from '@/components/Topo.vue'
import Rodape from '@/components/Rodape.vue'
import Menu from '@/components/Menu.vue'

const optionsAlert = { title: 'Mensagem', size: 'sm' }

export default {
  name: 'editarperfil',
  components: {
    Topo, Menu, Rodape
  },
  mounted() {
    this.getUserData()
  },
  data() {
    return {
      profile: localStorage.getItem("profile"),
      mail: null,
      passwd: null
    }
  },
  methods: {
    getUserData() {
      this.$clubApi.get('/user/data/complete')
        .then((response) => this.mail = response.data.object.holder.email)
        .catch((error) => this.$dialogs.alert(error.response.data.msg, optionsAlert));
    },
    changePasswd() {
      this.$clubApi.post('/user/update/passwd', { passwd: this.passwd })
        .then(() => this.$dialogs.alert('Atualização realizada!', optionsAlert))
        .catch((error) => this.$dialogs.alert(error.response.data.msg, optionsAlert));
    },
    changeMail() {
      this.$clubApi.post('/user/update/mail', { mail: this.mail })
        .then(() => this.$dialogs.alert('Atualização realizada!', optionsAlert))
        .catch((error) => this.$dialogs.alert(error.response.data.msg, optionsAlert))
    },
    cancel() {
      this.$router.push('/cancelar-assinatura');
    }
  }
}
</script>
